import { render, staticRenderFns } from "./add-to-cart-child.vue?vue&type=template&id=c160be6a"
import script from "./add-to-cart-child.vue?vue&type=script&lang=js"
export * from "./add-to-cart-child.vue?vue&type=script&lang=js"
import style0 from "./add-to-cart-child.vue?vue&type=style&index=0&id=c160be6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports